import { render, staticRenderFns } from "./SweetSpotOptimizeCard.vue?vue&type=template&id=57535827&scoped=true"
import script from "./SweetSpotOptimizeCard.vue?vue&type=script&lang=js"
export * from "./SweetSpotOptimizeCard.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotOptimizeCard.vue?vue&type=style&index=0&id=57535827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57535827",
  null
  
)

export default component.exports